import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createVolumeAction,
  deleteBookVolumesAction,
  getBookVolumesAction,
  getSingleBookAction,
  updateSingleVolumesAction,
} from '../../../../module/action/Book';
import { useNavigate } from 'react-router';
import DownloadIcon from '../../../../Assets/Icons/DownloadIcon';
import DeleteIconArticle from '../../../../Assets/Icons/DeleteIconArticle';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import BackIcon from '../../../../Assets/Icons/BackIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import { downloadFile } from '../../../../module/ConstantFunctions';
import { assetURL } from '../../../../api/utils';
import { Modal } from 'antd';
import Spinner from '../../../../Constants/Spinner';
import UploadIcon from '../../../../Assets/Icons/UploadIcon';
import { Link } from 'react-router-dom';
import ConfirmaModal from '../../../../Constants/ConfirmModal';

function BookVolumeRow({ a, i, deleteFunction, showModal }) {
  const navigate = useNavigate();
  const [downloadLoader, setDownloadLoader] = useState(false);

  return (
    <div className="md:table-row flex-wrap flex  w-full  py-2  " key={i}>
      <div className="md:table-cell font-semibold bg-[#f5f5f5] md:w-[51.352%] w-full pl-8 py-2	 rounded-l-xl">
        {a.volume_name}
      </div>
      <div className="md:table-cell font-semibold bg-[#f5f5f5] md:w-auto w-auto py-2 md:mr-0 mr-1	">
        {a.pdf_file ? (
          <div className="flex items-center">
            <button
              className="text-[#2a9134] bg-white py-[15px]  w-[160px]  rounded-xl border-[#2a9134] border-[1px] mr-4 leading-[10px]"
              onClick={() => showModal(a, 'Change PDF')}>
              Change PDF
            </button>
            <button
              disabled={downloadLoader}
              className="bg-[#DEEAE1] h-[40px] w-[40px] rounded-full flex items-center justify-center ml-4"
              onClick={() => {
                downloadFile(
                  a.pdf_file_url ? a.pdf_file_url : `${assetURL}${a.pdf_file}`,
                  `${a.volume_name}`,
                  'application/pdf',
                  setDownloadLoader
                );
              }}>
              {downloadLoader ? <Spinner color={'#2a9134'} /> : null}
              <span
                className={
                  downloadLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                }>
                <DownloadIcon />
              </span>
            </button>
          </div>
        ) : (
          <button
            className="ext-white bg-[#2a9134] py-[15px] text-white  rounded-xl w-[160px] leading-[10px]"
            onClick={() => {
              navigate(`/book/add-book?book=${a.bookId}`);
            }}>
            Upload PDF
          </button>
        )}
      </div>
      <div
        className="md:table-cell font-semibold bg-[#f5f5f5]  w-[152px]  pr-2 py-2 rounded-r-xl"
        onClick={() => deleteFunction(a._id)}>
        <div className="w-full justify-end flex">
          <button className="w-[152px] h-[40px] flex text-white bg-[#ca3030] py-[15px]  rounded-xl text-sm  justify-center items-center leading-[10px]">
            {/* <DeleteIconArticle svgProps={{ className: 'mr-[10.5px]', stroke: '#fff' }} pathProp={{ stroke: '#fff' }} /> */}
            <DeleteIcon svgProps={{ className: 'mr-[10.5px]' }} pathProp={{ fill: '#fff' }} />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

function BookVollumes() {
  let dispatch = useDispatch();

  const getSingleBook = useSelector(e => e.Book.getSingleBook);
  const volumesData = useSelector(e => e.Book.volumesData);
  const deleteBolumesDataLoader = useSelector(e => e.Book.deleteBolumesDataLoader);
  const [bookObj, setBookObj] = useState({});
  const [volumeObj, setVolumeObj] = useState([]);

  const [editData, setEditData] = useState(false);
  const [editDataLoader, setEditDataLoader] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalName, setModalName] = useState('');

  const [volumeToBeDeleted, setVolumeToBeDeleted] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteVolume = () => {
    const url = new URL(window.location);
    const bookID = url.searchParams.get('bookId');
    dispatch(deleteBookVolumesAction(volumeToBeDeleted, bookID));
  };

  useEffect(() => {
    if (!deleteBolumesDataLoader) setDeleteModalOpen(false);
  }, [deleteBolumesDataLoader]);

  const handleDeleteCancel = () => setDeleteModalOpen(false);

  const showModal = (a, name) => {
    setIsModalOpen(true);

    setEditData(a);
    setModalName(name);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setEditData(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setEditData(false);
  };

  useEffect(() => {
    const url = new URL(window.location);
    const bookID = url.searchParams.get('bookId');
    if (bookID) {
      dispatch(getSingleBookAction(bookID));
      dispatch(getBookVolumesAction(bookID));
    }
  }, []);

  useEffect(() => {
    if (getSingleBook) {
      setBookObj(getSingleBook);
    }
    if (volumesData) {
      setVolumeObj(volumesData);
    }
  }, [getSingleBook, volumesData]);

  const deleteFunction = id => {
    setVolumeToBeDeleted(id);
    setDeleteModalOpen(true);
  };

  return (
    <div className="BookVollumes my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <div className="flex items-center">
            <button
              className="bg-[#eef2f0] flex items-center justify-center w-[48px] h-[48px] rounded-xl mr-4"
              onClick={() => window.history.back()}>
              <BackIcon />
            </button>
            <div>
              <p className="text-[#7b867c] font-[Poppins-SemiBold]">Content</p>
              <h2 className="text-[24px] font-extrabold leading-[22px]">{bookObj && bookObj.bookName}</h2>
            </div>
          </div>
        </div>

        <Link to={`/book/add-book?book=${bookObj._id}`}>
          <button className="text-base flex justify-center items-center bg-gray-100 w-[218px]  py-[12px] rounded-xl  font-[Poppins-Bold]">
            <EditIcon width={26} height={24} fill="#000" />
            Edit Volumes
          </button>
        </Link>
      </div>

      <div className="w-full">
        <div className="md:table flex flex-col w-full my-6 border-spacing-y-[4px]">
          <div className="md:table-row w-full  py-6  ">
            <div className="md:table-cell font-[Poppins-SemiBold] bg-[#f5f5f5] w-[50%] pl-8 py-6 rounded-l-xl">
              Volumes
            </div>
            <div className="md:table-cell font-[Poppins-SemiBold] bg-[#f5f5f5] w-[calc(40%-152px)] py-6 hidden">
              PDF File
            </div>
            <div className="md:table-cell font-[Poppins-SemiBold] bg-[#f5f5f5] w-[152px]  pr-2 py-2 rounded-r-xl hidden ">
              Execution
            </div>
          </div>
          {volumeObj.map((a, i) =>
            a.volume_name ? <BookVolumeRow a={a} i={i} deleteFunction={deleteFunction} showModal={showModal} /> : null
          )}
        </div>
      </div>
      <Modal footer={false} title={modalName} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        {editData ? (
          <div className=" w-full">
            <div className="my-8">
              <p className="text-sm text-black font-semibold">PDF File</p>
              <p className="text-sm text-[#7b867c]  mt-2">Select PDF file from your computer</p>
              <label className="relative text-[#2a9134] flex mt-2 items-center">
                <input
                  type="file"
                  accept=".pdf"
                  className="hidden w-0 absolute"
                  onChange={ev => {
                    if (ev.target.files && ev.target.files[0]) {
                      let data = { ...editData };
                      data.pdf_file = ev.target.files[0];
                      setEditData(data);
                      setUpdateDisable(false);
                    }
                  }}
                />
                <div className="flex w-[150px] items-center justify-center mr-4 rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                  <UploadIcon className="mr-1.5" />
                  Upload
                </div>

                <p className="text-black text-sm font-medium font-[600] font-semibold w-[40%] text-text-ellipsis">
                  {editData.pdf_file
                    ? typeof editData.pdf_file === 'string' || editData.pdf_file === null
                      ? editData.pdf_file
                      : editData.pdf_file.name
                    : ''}
                </p>
              </label>
            </div>
          </div>
        ) : null}
        <button
          disabled={editDataLoader || updateDisable}
          className="relative mt-6 px-[90px] rounded-xl bg-[#2a9134] text-white py-3.5 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => {
            setEditDataLoader(true);
            dispatch(updateSingleVolumesAction(editData, editData._id, setEditDataLoader));
          }}>
          {editDataLoader ? <Spinner /> : 'Update'}
        </button>
      </Modal>

      <ConfirmaModal //
        loading={deleteBolumesDataLoader}
        open={deleteModalOpen}
        onCancel={handleDeleteCancel}
        title="Delete volume"
        content="Do you want to delete this volume?"
        cancelText="No"
        okText="Yes, Delete"
        onOk={handleDeleteVolume}
      />
    </div>
  );
}

export default BookVollumes;
